import { shiftEditorViewState } from "..";
import { Moment } from "moment";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateStartTimeShift", function updateStartTimeShift(newTime: Moment) {
    if (shiftEditorViewState().shift && newTime) {
        shiftEditorViewState().shift.startTime = newTime.clone();
    }
});